import { TableHeadItemRecurse } from '../../../../../components/TableHead';

export const tableHead: TableHeadItemRecurse[] = [
  { title: 'Ativo', flex: 2 },
  { title: 'Tipo', flex: 1.5 },
  { title: 'Data da posição' },
  { title: 'Valor' },
  { title: 'Variação', flex: 0.8 },
  { title: '', flex: 0.8 },
];
